import { PO_SHIPMENT_STATUS_COLORS } from '../../../utils/config/shipmentStatusColors';
import { parseDatTime } from '../../../utils/components/dateUtils';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import moment from 'moment';

const localizer = momentLocalizer(moment);
const MyCalendar = ({data}) => {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    setEvents(parseDatTime(data));
  }, [data]);

  const handleTaskClick = (event) => {
    const taskID = event.ID
    navigate(`/poStatusReport/task/${event.NAME}`, {state: { taskID }});
  };

  const CustomEvent = ({ event }) => (
    <div>
      {event.NAME && <div>Name: {event.NAME}</div>}
      {event.CARRIER && <div>Carrier: {event.CARRIER}</div>}
      {event.PALLETS && <div>Pallets: {event.PALLETS}</div>}
      {event.ITEM && <div>Items: {event.ITEM}</div>}
    </div>
  );

  return (
    <Calendar
      localizer={localizer}
      events={events}
      titleAccessor="name"
      defaultView="week"
      startAccessor="start"
      endAccessor="end"
      style={{ height: "100%", width: '100%' }}
      min={new Date(2024, 0, 1, 8, 0)}
      max={new Date(2024, 0, 1, 15, 30)}
      onDoubleClickEvent={handleTaskClick}
      eventPropGetter={(event) => {
        const normalizedStatus = event.STATUS ?.toLowerCase().replace(/\b\w/g, c => c.toUpperCase()); 
        const bg = PO_SHIPMENT_STATUS_COLORS[normalizedStatus] ?? "#999";
        return {
          style: {
            backgroundColor: bg,
            borderRadius: "5px",
            padding: "5px",
            boxShadow: "0px 0px 2px 1px rgb(0, 0, 0)",
            WebkitBoxShadow: "0px 0px 3px 1px rgb(255, 255, 255)",
          },
        };
      }}

      components={{ event: CustomEvent }}
    />
  );
};

export default MyCalendar;